import api from './api.service';

export interface MonitoredDatabase {
  id: string;
  name: string;
  type: 'postgresql' | 'mysql' | 'mongodb' | 'redis' | 'cassandra' | 'elasticsearch';
  host: string;
  port: number;
  status: 'online' | 'offline' | 'degraded' | 'unknown';
  connection_count: number;
  active_connections: number;
  idle_connections: number;
  max_connections?: number;
  queries_per_second: number;
  avg_query_time_ms?: number;
  application_id?: string;
  application_name?: string;
  db_type?: string;
}

export interface SlowQuery {
  id: string;
  database_id: string;
  query_text: string;
  query_type?: 'SELECT' | 'INSERT' | 'UPDATE' | 'DELETE' | 'OTHER';
  table_name?: string;
  execution_time_ms: number;
  avg_execution_time?: number;
  max_execution_time?: number;
  min_execution_time?: number;
  execution_count?: number;
  rows_examined?: number;
  rows_sent?: number;
  severity: 'low' | 'medium' | 'high' | 'critical';
  detected_at: string;
  last_execution?: string;
  query_plan?: any;
  database?: MonitoredDatabase;
  application_name?: string;
}

export interface ConnectionPoolData {
  time: string;
  active: number;
  idle: number;
  total: number;
}

export interface QueryPerformanceData {
  time: string;
  avgTime: number;
  p95: number;
  p99: number;
}

export const databaseApi = {
  getDatabases: (applicationId?: string): Promise<MonitoredDatabase[]> => {
    const params: any = {};
    if (applicationId && applicationId !== 'all') params.application_id = applicationId;
    return api.get('/v1/databases', { params });
  },

  getDatabase: (id: string): Promise<MonitoredDatabase> => {
    return api.get(`/v1/databases/${id}`);
  },

  getSlowQueries: (applicationId?: string, databaseId?: string, limit: number = 100): Promise<SlowQuery[]> => {
    const params: any = { limit };
    if (applicationId && applicationId !== 'all') params.application_id = applicationId;
    if (databaseId) params.databaseId = databaseId;
    return api.get('/v1/databases/slow-queries', { params });
  },

  getConnectionPoolMetrics: (databaseId: string, hours: number = 24): Promise<ConnectionPoolData[]> => {
    return api.get(`/v1/databases/${databaseId}/connection-pool`, { params: { hours } });
  },

  getQueryPerformanceMetrics: (databaseId: string, hours: number = 24): Promise<QueryPerformanceData[]> => {
    return api.get(`/v1/databases/${databaseId}/query-performance`, { params: { hours } });
  },
};
